export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.11.5-1625.52",
  commitId: "3767b57654803c73cdbc8275ade73e211ed85fed",
  commitTime: "2026-11-05T16:25:52.000Z",
});
